import React from 'react'
import { Container, Row } from '@kogk/common'

export type InformationStatisticType = { title: string; value: number }

const Group: React.FC<{
  title: string
  statistics: InformationStatisticType[]
}> = ({ title, statistics }) => {
  return (
    <div className='col-lg-6 pb-3 pb-lg-0'>
      <h4 className='pb-2'>{title}</h4>
      <div className='d-flex'>
        {statistics
          .filter(stat => stat.value)
          .map((stat, idx) => (
            <div key={idx} className='col-6 p-0'>
              <h1 className='information-banner__percentage'>{`${stat.value}%`}</h1>
              <p className='pt-2'>{stat.title}</p>
            </div>
          ))}
      </div>
    </div>
  )
}

const InformationBanner: React.FC<{
  items: { title: string; statistics: InformationStatisticType[] }[]
}> = ({ items }) => {
  if (!items) {
    return null
  }
  return (
    <Container className='page-slice-spacer__smaller'>
      <Row>
        <div className='col-lg-8 offset-lg-2 d-flex flex-column flex-lg-row flex-wrap px-0'>
          {items.map((item, idx) => (
            <Group key={idx} title={item.title} statistics={item.statistics} />
          ))}
        </div>
      </Row>
    </Container>
  )
}

export default InformationBanner
